var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/view/VControlButton
 */
import $ from 'jquery';
import BaseView from './BaseView';
import { createSVGIconFromPath } from './SVGUtils';
/**
 * @classdesc
 */
var VControlButton = /** @class */ (function (_super) {
    __extends(VControlButton, _super);
    /**
     * @param {string} iconName Icon
     * @param {Array.<string>} [paths] paths Paths
     */
    function VControlButton(iconName, paths) {
        var _this = this;
        var classIcon = "icon-".concat(iconName);
        var jqElement = $("<div class=\"v-control-button\" aria-pressed=\"false\"><span class=\"".concat(classIcon, "\" /></div>"));
        if (paths) {
            paths.forEach(function (path) { return jqElement.find(".".concat(classIcon)).append("<span class=\"".concat(path, "\"/>")); });
        }
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {JQuery}
         */
        _this.jqTooltip_ = $('<div class="v-tooltip" />');
        /**
         * @private
         * @type {string|null}
         */
        _this.tooltipText_ = null;
        /**
         * @private
         * @type {boolean}
         */
        _this.enabled_ = false;
        jqElement.append(_this.jqTooltip_.hide());
        return _this;
    }
    /**
     * Enable button
     */
    VControlButton.prototype.enable = function (twoState) {
        if (twoState === void 0) { twoState = true; }
        this.enabled_ = true;
        if (twoState) {
            this.jqElement_.addClass('enabled');
        }
    };
    /**
     * Disable button
     */
    VControlButton.prototype.disable = function () {
        this.enabled_ = false;
        this.jqElement_.removeClass('enabled');
    };
    /**
     * @return {boolean} Return if button is enabled
     */
    VControlButton.prototype.isEnabled = function () {
        return this.enabled_;
    };
    /**
     * @param {string|Array.<string>} svg SVG content
     */
    VControlButton.prototype.setSvgPath = function (svg) {
        var arrSvg = Array.isArray(svg) ? svg : [svg];
        this.jqElement_.append(createSVGIconFromPath(arrSvg.join('')));
    };
    /**
     * @api
     * @param {string} text Text
     */
    VControlButton.prototype.setTooltip = function (text) {
        var _this = this;
        this.jqTooltip_.text(text);
        this.tooltipText_ = text;
        this.jqElement_.on('mouseover', function (e) {
            if (_this.tooltipText_ && _this.tooltipText_.length > 0 && $(e.target).hasClass('v-control-button')) {
                _this.jqTooltip_.show();
            }
        });
        this.jqElement_.on('mouseleave', function () { return _this.jqTooltip_.hide(); });
        this.jqTooltip_.on('mouseover', function () { return _this.jqTooltip_.hide(); });
    };
    return VControlButton;
}(BaseView));
export default VControlButton;
//# sourceMappingURL=VControlButton.js.map